import ColorHash from 'color-hash';
import tinycolor2 from 'tinycolor2';
import { Palette, darken } from '../styles';

const colorHash = new ColorHash();
const wcagAAAMinimumContrastRatio = 7.1;

const getUserColor = (palette: Palette, userId: string | number, userName: string) => {
  if (!userId || !userName) {
    return palette.skeleton.badge;
  }

  let backgroundColor = `rgb(${colorHash.rgb(userId + userName).toString()})`;
  const isReadable = tinycolor2.isReadable(backgroundColor, palette.text.onContrasted, {
    level: 'AAA',
    size: 'small',
  });

  while (
    tinycolor2.readability(backgroundColor, palette.text.onContrasted) <
      wcagAAAMinimumContrastRatio &&
    !isReadable
  ) {
    backgroundColor = darken(backgroundColor, 0.1);
  }

  return backgroundColor;
};

export default getUserColor;
